import { TextField } from "@mui/material";
import { useState } from "react";

export function CustomTextField({
  label,
  placeholder,
  error,
  helperText,
  value,
  onChange,
}) {
  const [focused, setFocused] = useState(false);

  const labelStyle = {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "15px",
    marginBottom: "6px",
    display: "block",
  };

  return (
    <div style={{ marginBottom: "25px" }}>
      <label style={labelStyle}>
        {label} <span style={{ color: "red" }}>*</span>
      </label>
      <TextField
        fullWidth
        required
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        variant="outlined"
        error={error}
        helperText={helperText}
        sx={{
          backgroundColor: !focused && !value ? "#f0f0f0" : "#fff",
          borderRadius: "12px",
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            "& fieldset": {
              borderColor: focused ? "#3B035E" : "#ccc",
              borderWidth: focused ? "3px" : "1px",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#3B035E",
            },
            "& input": {
              padding: "8px 12px",
              fontSize: "15px",
            },
          },
        }}
      />
    </div>
  );
}
